module.exports = function() {
  return new Worker(__webpack_public_path__ + "05e0bb0768c0fc26134b.worker.js");
};